import * as React from 'react';
import { MipSessionsListTable } from './MipSessionsListTable';
import DocumentTitle from '../../../misc/components/DocumentTitle';
import { ODataParams, Query } from '../../../Components/Query';
import { useCurrentStudyConfigurationContext } from '../../../Core/CurrentStudyConfigurationContext';
import { useWebPortalApiClient } from '../../../misc/api/WebPortalTokenClient';

export const MipSessionsListScreen = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `visit/subject/site/studyId eq ${study.id} `;

        const select = "id,name,occurred,visit,technician,received,overreader,status,challengeIsClosed,overreadChallengeStatus,testsCount,analysisSetId";

        const expand = "analysisSets($select=id,status,type),visit($select=id,name,subject;$expand=subject($select=id,number,site;$expand=site($select=id,number,studyId)))";

        return await client.client.getMipSessions(select, filter, params.orderby, expand, params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="MIP Sessions | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "occurred", condition: "desc" }]}>
                <MipSessionsListTable />
            </Query>
        </DocumentTitle>
    );
};
